import { render } from "./MetamaskVote.vue?vue&type=template&id=06bcf000"
import script from "./MetamaskVote.vue?vue&type=script&lang=js"
export * from "./MetamaskVote.vue?vue&type=script&lang=js"

import exportComponent from "F:\\marksix.com\\snapshot\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__